export default __webpack_public_path__ + "static/media/rex.c4d9f4ac.svg";